__turbopack_context__.v({
  "areaPulse": "WatchlistInsightsSkeleton-module__gqpmwW__areaPulse",
  "bone": "WatchlistInsightsSkeleton-module__gqpmwW__bone",
  "boneLight": "WatchlistInsightsSkeleton-module__gqpmwW__boneLight",
  "boneText": "WatchlistInsightsSkeleton-module__gqpmwW__boneText",
  "donut": "WatchlistInsightsSkeleton-module__gqpmwW__donut",
  "donutPulse": "WatchlistInsightsSkeleton-module__gqpmwW__donutPulse",
  "historyArea": "WatchlistInsightsSkeleton-module__gqpmwW__historyArea",
  "historyLine": "WatchlistInsightsSkeleton-module__gqpmwW__historyLine",
  "historyShimmer": "WatchlistInsightsSkeleton-module__gqpmwW__historyShimmer",
  "shimmer": "WatchlistInsightsSkeleton-module__gqpmwW__shimmer",
});
